import React from 'react';
import { trackPixelEvent } from './MetaPixel';
const PAINS = ['Domingo a la noche buscando actividades que nunca quedan como querés.', 'Clases improvisadas porque no tenés material listo y secuenciado para cada nivel.', 'Alumnos que no participan porque el material es aburrido o está mal graduado.', 'Horas perdidas en Google buscando ejercicios de gramática o vocabulario.', 'Planificaciones hechas de apuro que el directivo igual te devuelve.', 'Trabajar en dos o tres escuelas y no tener tiempo de preparar material diferente para cada una.'];
export function PainSection() {
  return <section className="py-16 px-6 bg-white" data-id="element-105">
      <div className="max-w-2xl mx-auto text-center mb-10" data-id="element-106">
        <h2 className="text-3xl font-extrabold text-gray-900 mb-3" data-id="element-107">
          Si sos docente de inglés en primaria o secundaria,
          <br data-id="element-108" />
          <span className="text-blue-600" data-id="element-109">esto te va a sonar familiar:</span>
        </h2>
      </div>
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-110">
        {PAINS.map(pain => <div key={pain} className="flex items-start gap-3 bg-red-50 border border-red-100 rounded-xl p-4" data-id="element-111">
            <span className="text-red-500 text-lg mt-0.5" data-id="element-112">✗</span>
            <p className="text-gray-700 text-sm" data-id="element-113">{pain}</p>
          </div>)}
      </div>
      <div className="max-w-2xl mx-auto mt-10 text-center" data-id="element-114">
        <p className="text-xl font-bold text-gray-900 mb-8" data-id="element-115">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>
        <a href="#precios" onClick={() => trackPixelEvent('Lead', {
        content_name: 'Pain Section CTA',
        content_category: 'Pack de Inglés 360'
      })} className="inline-block bg-blue-600 text-white font-extrabold text-lg py-4 px-8 rounded-full shadow-xl hover:bg-blue-700 hover:scale-105 active:scale-95 transition-transform duration-150" data-id="element-116">
          BASTA DE DOMINGOS PERDIDOS — QUIERO MI PACK DE INGLÉS
        </a>
      </div>
    </section>;
}